<template>
  <el-drawer
    class="custom-draw"
    :title="title"
    :visible="isVisible"
    @close="beforeClose"
    @closed="closeDialog"
    :size="width"
    :append-to-body="appendToBody"
    :wrapperClosable="wrapperClosable"
  >
    <slot name="title" slot="title"></slot>
    <slot></slot>
  </el-drawer>
</template>


<script>
export default {
  props: {
    visible: [Boolean],
    title: {
      type: String,
      default: 'dialog title',
    },
    width: {
      type: String,
      default: '850px',
    },
    appendToBody: {
      type: Boolean,
      default: true,
    },
    wrapperClosable: {
      type: Boolean,
      default: true,
    },
  },
  data: function () {
    return {
      isVisible: false,
    };
  },
  watch: {
    visible(newVal) {
      this.$nextTick(() => {
        this.isVisible = newVal;
      });
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.isVisible = this.visible;
    });
  },
  methods: {
    // 关闭弹窗前
    beforeClose: function () {
      this.isVisible = false;
    },
    // 关闭弹窗
    closeDialog: function () {
      this.$emit('close', false);
    },
  },
};
</script>

<style lang='scss'>
@import '@/style/colors.scss';

.custom-draw .el-drawer__header {
  margin-bottom: 0;
  padding: 0 18px;
  height: 50px;
  line-height: 50px;
  background: #ffffff;
  box-shadow: 0px 1px 0px 0px #e9ebec;
  span {
    color: #495057;
    font-size: 14px;
    font-weight: 500;
  }
  .el-dialog__close {
    color: #495057;
    font-weight: 500;
  }
}
</style>
